import * as C from '../constants';
import * as THREE from 'three';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

const BLADES = [2, 3, 4];

export const useBlades = (materials) => {
  const blades = useSelector((state: any) => state.app[C.SET_BLADES]);

  if (materials) {
    if (blades) {
      BLADES.forEach((bladeKey) => {
        const material = materials?.[`blades${bladeKey}`];

        if (material) {
          const isVisible = parseInt(blades) === bladeKey;
          material.visible = isVisible;
        }
      });
    }
  }

  return null;
};
